import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/finance/cashflow')({
  component: () => <PageStub title="Cashflow Forecaster" description="Predict and manage cash flow" />,
});
